import { connect } from 'react-redux';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
import { twilioActions } from '../../../../app/middleware/twilio/actions/twilioActions';
import * as conversationActions from '../../../conversation/actions/conversation';
import { notificationActions } from '../../../notifications/actions/notification';
import { addCallerActions } from '../../../shared/addCallerModal/actions/addCaller';
import { transferToAgentActions } from '../../../shared/transferToAgentModal/actions/transferToAgentModal';
import { transferToNumberActions } from '../../../shared/transferToNumberModal/actions/transferToNumberModal';
import { transferToQueueModalOpen } from '../../../shared/transferToQueueModal/reducers/transferToQueueModal';
import { actions } from '../../../telephony/actions/telephony';
import Phone from '../components/Phone';
const { conversationClose } = conversationActions.actions;
const { notificationAdd } = notificationActions;
const mapStateToProps = (state, ownProps) => {
    return {
        browser: state.keyboardShortcuts.browser,
        meta: state.telephony.meta,
        isOnTrial: typeof state.settings.organization.organization.trial_ended_at ===
            'string'
            ? false
            : true,
        isOnHold: state.telephony.isOnHold,
        isOnMute: state.telephony.isOnMute,
        canMakeOutBoundCall: ownProps.canMakeOutBoundCall,
        metaConversation: ownProps.metaConversation,
        isInternalCall: ownProps.isInternalCall,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        telephonySendDigits: (digit) => dispatch(twilioActions.twilioSendDigits({ digit: digit })),
        telephonySetHold: bindActionToPromise(dispatch, actions.telephonySetHold),
        telephonySetMute: bindActionToPromise(dispatch, actions.telephonySetMute),
        conversationClose: bindActionToPromise(dispatch, conversationClose),
        notificationAdd: (payload) => dispatch(notificationAdd(payload)),
        transferToNumberModalOpen: (metaConversation) => dispatch(transferToNumberActions.transferToNumberModalOpen({
            metaConversation: metaConversation,
        })),
        transferToAgentModalOpen: (metaConversation) => dispatch(transferToAgentActions.transferToAgentModalOpen({
            metaConversation: metaConversation,
        })),
        transferToQueueModalOpen: (payload) => dispatch(transferToQueueModalOpen(payload)),
        addCallerModalOpen: (metaConversation) => dispatch(addCallerActions.addCallerModalOpen({
            metaConversation: metaConversation,
        })),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Phone);
